module.exports = __webpack_public_path__ + "static/img/nothin-food.2875c77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/nothin-food.png
// module id = TY/Q
// module chunks = 0